/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const PLACE_ORDER = 'PLACE_ORDER';
const PLACE_ORDER_COMPLETE = 'mbp-checkout/PLACE/ORDER/COMPLETE';
const UPDATE_COMPLETE_PAYMENT_DETAILS = 'UPDATE_COMPLETE_PAYMENT_DETAILS';
const LOAD_COMPLETE_PAYMENT_DETAILS = 'LOAD_COMPLETE_PAYMENT_DETAILS';
const CHECKOUT_PAYMENT_METHODS_LOAD = 'mbp-checkout/PAYMENT/METHODS/LOAD';
const ACTIVE_PAYMENT_METHOD = 'mbp-checkout/ACTIVE_PAYMENT_METHOD';
const INACTIVE_PAYMENT_METHOD = 'mbp-checkout/INACTIVE_PAYMENT_METHOD';
const SHOW_ORDER_CONFIRMATION = 'SHOW_ORDER_CONFIRMATION';
const APPLY_GIFT_CARD_PROCESS_COMPLETED = 'mbp-checkout/APPLY_GIFT_CARD_PROCESS_COMPLETED';
const RECORD_PAYMENT_METHOD_TYPE = 'mbp-checkout/RECORD_PAYMENT_METHOD_TYPE';
const RECORD_PAYMENT_METHOD_TYPE_COMPLETED = 'mbp-checkout/RECORD_PAYMENT_METHOD_TYPE_COMPLETED';
const PROCESS_NBCU_MOVIE = 'mbp-checkout/PROCESS/NBCU/MOVIE';
const POST_ORDER_COMPLETE_ATTRIBUTION_DATA = 'mbp-checkout/POST/ORDER/COMPLETE/ATTRIBUTTION/DATA';
const PROCESS_DEFAULT_PAYMENT = 'mbp-checkout/PROCESS_DEFAULT_PAYMENT';
const PROCESS_DEFAULT_PAYMENT_COMPLETED = 'mbp-checkout/PROCESS_DEFAULT_PAYMENT_COMPLETED';

export default {
    PLACE_ORDER,
    PLACE_ORDER_COMPLETE,
    UPDATE_COMPLETE_PAYMENT_DETAILS,
    LOAD_COMPLETE_PAYMENT_DETAILS,
    ACTIVE_PAYMENT_METHOD,
    INACTIVE_PAYMENT_METHOD,
    CHECKOUT_PAYMENT_METHODS_LOAD,
    SHOW_ORDER_CONFIRMATION,
    APPLY_GIFT_CARD_PROCESS_COMPLETED,
    RECORD_PAYMENT_METHOD_TYPE,
    RECORD_PAYMENT_METHOD_TYPE_COMPLETED,
    PROCESS_NBCU_MOVIE,
    POST_ORDER_COMPLETE_ATTRIBUTION_DATA,
    PROCESS_DEFAULT_PAYMENT,
    PROCESS_DEFAULT_PAYMENT_COMPLETED,
};
